import { ILocation } from '@models/interfaces/ILocation';
import { DefaultLocationFormatter } from '../default-location-formatter';

export class CnuLocationFormatter extends DefaultLocationFormatter {
  format(location: ILocation): string[] {
    return [[location.CityName, location.PlaceName, location.StreetNumber, location.AliasName].filter(s => s).join(', ')];
  }
}
